import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webAbout`

// Get all about page data
export const getWebAboutApi = () => {
  return axiosInstance.get(`${serverUrl}/getAboutSection`)
}

// Get about page data by ID
export const getWebAboutByIdApi = (id) => {
  return axiosInstance.get(`${serverUrl}/${id}`)
}

// Add or update about page data
export const addOrUpdateWebAboutApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/addOrUpdateWebAbout`, formData)
}

// Combined service for all about page operations
const webAboutService = {
  getWebAbout: getWebAboutApi,
  getWebAboutById: getWebAboutByIdApi,
  addOrUpdateWebAbout: addOrUpdateWebAboutApi
}

export default webAboutService
